import type { FC, PropsWithChildren } from 'react'
import { StyledEngineProvider, ThemeProvider as MuiThemeProvider } from '@mui/material/styles'

import theme from '~/shared/lib/theme'

/**
 * StyledEngineProvider injectFirst makes Emotion inject its styles before the
 * app's plain CSS (index.css), so `sx`/`styled` rules win at equal specificity.
 */
export const ThemeProvider: FC<PropsWithChildren> = ({ children }) => (
  <StyledEngineProvider injectFirst>
    <MuiThemeProvider theme={theme}>{children}</MuiThemeProvider>
  </StyledEngineProvider>
)
